<template>
  <div class="project-summary">
    <ProjectSummaryContent
      :missing-project="!project"
      :project-name="project ? getProjectDisplayName(project) : undefined"
      :financial-officer-name="project?.executor?.person?.fullName"
      :customer-name="project?.executor?.knownBusinessEntityName"
    >
      <template v-if="project" #project>
        <PBadge v-if="project.isActive === false" color="warning" size="sm">Inactief</PBadge>
        <ModelEditLink v-if="enableModelLinks" :model="project">{{
          getProjectDisplayName(project)
        }}</ModelEditLink>
        <span v-else>{{ getProjectDisplayName(project) }}</span>
      </template>
      <template v-if="project?.executor?.person" #financialOfficer>
        <ModelEditLink v-if="enableModelLinks" :model="project.executor.person">{{
          project.executor.person.fullName
        }}</ModelEditLink>
        <span v-else>{{ project.executor.person.fullName }}</span>
      </template>
      <template v-if="project?.executor" #customer>
        <ModelEditLink
          v-if="enableModelLinks && project.executor.knownBusinessEntity"
          :model="project.executor.knownBusinessEntity"
          >{{ project.executor.knownBusinessEntityName }}</ModelEditLink
        >
        <span v-else>{{ project.executor.knownBusinessEntityName }}</span>
      </template>
    </ProjectSummaryContent>
  </div>
</template>

<script setup lang="ts">
import ProjectSummaryContent from "./ProjectSummaryContent.vue"
import { getProjectDisplayName } from "@/helper/models/project-display-helper"
import ModelEditLink from "@/components/misc/ModelEditLink.vue"
import PBadge from "@/components/elements/PBadge.vue"
import type { Project } from "@/models/project.model"

withDefaults(
  defineProps<{
    project?: Project | null
    enableModelLinks?: boolean
  }>(),
  {
    enableModelLinks: false
  }
)
</script>
